<script lang="ts">
  export let label = "Unknown";
  export let style = ""
</script>

<div class="data" {style}>
  <label class="heading_data_card" for="data">{label}</label>
  <div id="data">
    <slot />
  </div>
</div>

<style>
    label {
        font-size: 0.7rem;        
        font-weight: bold;
        margin-bottom: 10px;
        display: block;
    }

    .data {
        margin-bottom: 20px;
        font-size: 1.5em;
    }
    .heading_data_card{
      font-size:22px;
      color:#93cdbf;
    }
  
</style>